export const fetchPermissions = async (token) => {
    const requestURL = encodeURI(
      `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/permissions`
    );
    const headers = new Headers({
      Authorization: `Bearer ${token}`,
    });

    try {
      const data = await fetch(requestURL, {
        method: 'GET',
        headers,
      });

      if (!data.ok) {
        throw {
          message: `Permissions Fetch Data Not Okay: ${data.status}`,
          code: data.status,
        };
      }

      const jsonData = await data.json();
      return jsonData;
    } catch (error) {
      const isInternalError = error instanceof Error;
      const errorType = 'fetchPermissions';
      const errorCode = isInternalError ? 500 : error.errorCode;
      return null
    }
  };
